import { useState } from "react";
import { Button, Card, CardBody, Field, TextArea, TextInput } from "@odingard/design-system";
import { routeMeta, usePageMeta } from "../../lib/usePageMeta";

export function Contact() {
  usePageMeta(routeMeta("/contact"));
  const [sent, setSent] = useState(false);
  return (
    <section className="section">
      <div className="container container--narrow">
        <div className="section__head" style={{ textAlign: "center" }}>
          <h1>Contact Odingard</h1>
          <p>Talk to our team about enterprise plans, security reviews, or procurement.</p>
        </div>
        <Card>
          <CardBody>
            {sent ? (
              <div className="ods-state">
                <div className="ods-state__icon" aria-hidden="true">
                  ✓
                </div>
                <h3>Thanks, we&apos;ll be in touch</h3>
                <p>A member of our team will reach out shortly.</p>
              </div>
            ) : (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setSent(true);
                }}
              >
                <Field label="Full name">{(id) => <TextInput id={id} name="name" required />}</Field>
                <Field label="Work email">{(id) => <TextInput id={id} name="email" type="email" required />}</Field>
                <Field label="Company">{(id) => <TextInput id={id} name="company" />}</Field>
                <Field label="How can we help?">{(id) => <TextArea id={id} name="message" rows={4} required />}</Field>
                <Button type="submit" block>
                  Send message
                </Button>
              </form>
            )}
          </CardBody>
        </Card>
      </div>
    </section>
  );
}
